import React from "react";

export default function LoadingGridCard(props) {

    return (
        <div className="grid-card">
            <div>
                <div className="spinner-container">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
            <div className="grid-card-content">
                <p className="card-title bg-light">&nbsp;</p>
                <p className="card-tertiary-title bg-light">&nbsp;</p>
                <p className="card-price spacer bg-light">&nbsp;</p>
            </div>
        </div>
    )
} 